import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Table, Params, Actions, Merge } from 'nallian-table-builder-ui';
import { Loader } from 'nallian-shared-ui/lib/components';
import { APP_INSTALLATIONS_RESOURCE, INFINITE_SCROLL, TABS } from '../../constants';
import apiRoutes from '../../../../app/api/routes';
import TypeToConfirmModal from '../../../app/components/TypeToConfirmModal';
import RemoveAppInstallationService from '../../services/removeAppInstallationService';

const AppInstallations = ({
  appFetch,
  dispatchRemoveAppInstallationDelete,
  removeAppInstallationFetch,
}) => {
  const { t } = useTranslation();

  const [removalItem, setRemovalItem] = useState(null);

  const handleCancel = useCallback(() => setRemovalItem(null), [setRemovalItem]);
  const handleSetRemovalItem = useCallback((_, item) => setRemovalItem(item), [setRemovalItem]);

  const handleRemove = useCallback(() => {
    dispatchRemoveAppInstallationDelete(
      appFetch.value?.id,
      removalItem.id,
      () => setRemovalItem(null),
      t
    );
  }, [removalItem, appFetch.value, dispatchRemoveAppInstallationDelete, t]);

  if (appFetch.pending) {
    return <Loader active inline="centered" />;
  }

  return (
    <>
      <Table
        infiniteScroll={INFINITE_SCROLL}
        resource={APP_INSTALLATIONS_RESOURCE}
        url={apiRoutes.apps(appFetch.value?.id)}
        rootTableProperty="appInstallations"
        pageSize={50}
        idProp="tag"
        noUserSettings
        filtered
        sorted
      >
        <Params.String
          link={`/apps/${appFetch.value?.id}/${TABS.INSTALLATIONS}/:id`}
          name="name"
          width="16rem"
          minWidth="16rem"
          grow
          noFilter
        />
        <Params.String name="tag" width="16rem" minWidth="16rem" grow noFilter />
        <Merge width="4.5rem" align="center" type="Menu" hasRight="apps/delete">
          <Actions.Button
            iconbutton
            icon="trash"
            label={t('removeAppInstallation')}
            content={t('removeAppInstallation')}
            onClick={handleSetRemovalItem}
          />
        </Merge>
      </Table>
      {removalItem && (
        <TypeToConfirmModal
          onConfirm={handleRemove}
          onCancel={handleCancel}
          header={t('app:areYouSureRemoveAppInstallation', { item: removalItem })}
          loading={removeAppInstallationFetch.pending}
          value={removalItem.name}
        />
      )}
    </>
  );
};

AppInstallations.propTypes = {
  appFetch: PropTypes.object.isRequired,
  dispatchRemoveAppInstallationDelete: PropTypes.func.isRequired,
  removeAppInstallationFetch: PropTypes.object.isRequired,
};

export default RemoveAppInstallationService(AppInstallations);
